
import { useAuth } from "../context/AuthContext";
import { logSecurityEvent } from "@/utils/securityUtils";

export type UserRole = {
  role: 'admin' | 'user';
  approved: boolean;
}

export function useAuthSession() {
  try {
    const auth = useAuth();
    
    const userId = auth.session?.user?.id || null;
    
    // Log session activity for security monitoring
    if (userId) {
      // Only log occasionally to avoid excessive logging
      const shouldLog = Math.random() < 0.1; // 10% chance of logging
      if (shouldLog) {
        logSecurityEvent(
          userId,
          'session_activity',
          'User session activity recorded',
          { timestamp: new Date().toISOString() }
        ).catch(console.error); // Catch but don't block on error
      }
    }
    
    // Ensure we always return consistent values, no conditionals in hook results
    return {
      session: auth.session,
      isLoading: auth.loading,
      isAuthenticated: !!auth.session,
      userId: userId
    };
  } catch (error) {
    console.error("Error in useAuthSession:", error);
    
    // Log the error for security analysis
    logSecurityEvent(
      null,
      'session_error',
      'Error accessing authentication context',
      { error: String(error) }
    ).catch(console.error);
    
    // Return fallback values if there's an error accessing auth context
    return {
      session: null,
      isLoading: false,
      isAuthenticated: false,
      userId: null
    };
  }
}
